import { Row } from "antd"
import { AiFeedbackForm, Card, Divider, Icon, notification, Text, Title } from "components/common"
import { IconText } from "components/custom"
import { useAddFeatureFeedbackMutation, useLazyGetFeatureFeedbackOptionsQuery } from "features/shared/api"
import { t } from "i18next"
import { useEffect, useRef, useState } from "react"
import theme from "utils/themeVars"
import { renderUnorderedList } from "utils"

export const MeetingAINotes = ({ details, from = "", meetingId }) => {
  const [likeColor, setLikeColor] = useState(theme["text-color-secondary"])
  const [dislikeColor, setDislikeColor] = useState(theme["text-color-secondary"])
  const aiFeedbackRef = useRef()

  const [addFeedback] = useAddFeatureFeedbackMutation()
  const [getFeedbackOptions, { data: feedbackOptions }] = useLazyGetFeatureFeedbackOptionsQuery()

  useEffect(() => {
    from === "meetingDetailView" && getFeedbackOptions({ entity: "management_meeting" }, true)
  }, [])

  const handleLike = () => {
    likeColor == theme["text-color-secondary"] &&
      addFeedback({
        feedbackOptionId: feedbackOptions?.[0]?.id,
        rating: 5,
        entity: "management_meeting",
        entityId: meetingId,
      })
        .unwrap()
        .then(() => {
          notification.success({ message: t("Feedback has been submitted successfully") })
        })
        .catch(e => {
          notification.error({ message: e?.message })
        })

    if (likeColor == theme["text-color-secondary"] && dislikeColor == theme["text-color-secondary"])
      setLikeColor(theme["link-color"])
    else if (likeColor == theme["text-color-secondary"] && dislikeColor == theme["link-color"]) {
      setLikeColor(theme["link-color"])
      setDislikeColor(theme["text-color-secondary"])
    } else if (likeColor == theme["link-color"]) {
      setLikeColor(theme["text-color-secondary"])
    }
  }

  const handleDislike = () => {
    dislikeColor == theme["text-color-secondary"] && aiFeedbackRef.current?.setVisible(true)
    if (dislikeColor == theme["text-color-secondary"] && likeColor == theme["text-color-secondary"])
      setDislikeColor(theme["link-color"])
    else if (dislikeColor == theme["text-color-secondary"] && likeColor == theme["link-color"]) {
      setDislikeColor(theme["link-color"])
      setLikeColor(theme["text-color-secondary"])
    } else if (dislikeColor == theme["link-color"]) {
      setDislikeColor(theme["text-color-secondary"])
    }
  }

  return (
    <>
      <Card
        title={
          from === "meetingDetailView" && (
            <IconText icon="SvgIconAi" textType="secondary" title={t("AI Generated Notes")} />
          )
        }
        style={{ marginTop: "8px", textAlign: "start", boxShadow: "none" }}
        bodyStyle={{ maxHeight: "400px", overflowY: "auto" }}
        headStyle={{ minHeight: "16px" }}
      >
        <Title level={5} style={{ marginTop: "4px" }}>
          {t("Agenda")}
        </Title>
        {renderUnorderedList(details?.agenda)}

        <Divider style={{ borderTop: "1px dashed #d9d9d9", margin: "16px 0" }} />

        <Title level={5}>{t("Minutes of Meeting")}</Title>
        {details?.minutesOfMeeting?.split(".")?.filter(Boolean)?.length
          ? renderUnorderedList(details?.minutesOfMeeting?.split(".")?.filter(Boolean))
          : null}

        <Divider style={{ borderTop: "1px dashed #d9d9d9", margin: "16px 0" }} />

        <Title level={5}>{t("Action Items")} </Title>
        {renderUnorderedList(details?.action_items?.general, "#0091BA")}
        <ul>
          {details?.action_items?.individual?.map(item => (
            <li className="gray-900">
              <Text strong>{item?.name}</Text>
              {": " + item?.task}
            </li>
          ))}
        </ul>

        <Divider style={{ borderTop: "1px dashed #d9d9d9", margin: "16px 0" }} />

        <Title level={5}>{t("Next Meeting")}</Title>
        {renderUnorderedList(details?.next_meeting_agenda)}
      </Card>

      {from === "meetingDetailView" && (
        <Card
          style={{
            boxShadow: "2px 2px 7px rgba(0, 0, 0, 0.1)",
            marginTop: "8px",
          }}
          bodyStyle={{ padding: "5px 19px", borderRadius: 5 }}
          bordered={false}
        >
          <Row justify="space-between" align={"middle"}>
            <Text>{t("Was this helpful? Share your feedback.")}</Text>
            <div style={{ display: "flex", gap: 8 }}>
              <Icon
                hasBackground
                icon="BiSolidLike"
                size="14px"
                style={{ borderRadius: "1rem", margin: -4, color: likeColor, cursor: "pointer" }}
                iconContainerStyle={{ padding: 10, "--icon-bg-color": theme["table-row-hover-bg"] }}
                onClick={() => handleLike()}
              />
              <Icon
                hasBackground
                icon="BiSolidDislike"
                size="14px"
                style={{ borderRadius: "1rem", margin: -4, color: dislikeColor, cursor: "pointer" }}
                iconContainerStyle={{ padding: 10, "--icon-bg-color": theme["table-row-hover-bg"] }}
                onClick={() => handleDislike()}
              />
            </div>
          </Row>
        </Card>
      )}
      <AiFeedbackForm ref={aiFeedbackRef} entityId={meetingId} entity={"management_meeting"} from={"meetingDetail"} />
    </>
  )
}
